<template>
    <div>
        <div class="framiactusection">
            <div class="framiactubutton">
                <i :class="`fa fa-${$t(`preamble.buttonicon`)} mx-2 fc-f7`"></i>
                <a :href="url" v-html="$t(`preamble.button`)"></a>
            </div>
        </div>
        <Part section="preamble" :chapters="chapters">
            <template v-slot:after_chapter>
                <b-container class="peertube-wrapper">
                    <b-row>
                        <b-col cols="12" lg="5">
                            <h4 class="mb-3">
                                <i class="fas fa-money-bill-trend-up mr-1"></i>
                                <span v-html="$t(`preamble.conference.title`)"></span>
                            </h4>
                            <div v-html="$t(`preamble.conference.description`)" class="mb-4"></div>
                            <p>
                                <a :href="$t('preamble.conference.link.url')"
                                   target="_blank"
                                   rel="noopener"
                                   class="mb-3"
                                ><strong>{{ $t('preamble.conference.link.label') }}</strong></a>
                            </p>
                        </b-col>
                        <b-col cols="12" lg="7">
                            <ResponsiveIframe
                                :src="$t('preamble.conference.embed_url')"
                                :title="$t('preamble.conference.title')"
                                :figcaptionSrOnly='true'
                            />
                        </b-col>
                    </b-row>
                </b-container>
            </template>
        </Part>
	</div>
</template>
<script>
import Part from './Part.vue';
import ResponsiveIframe from "./ResponsiveIframe.vue";
export default {
    name: 'Preamble',
    components: {
        ResponsiveIframe,
        Part
    },
    data() {
        return {
            chapters: {
                default: {
                    type: 'two',
                    quote: false,
                    title: false,
                },
			},
			url: '#',
        }
    },
  created() {
      this.getArticles();
    },
  methods: {
    getArticles() {
      let url = 'https://framablog.org/tag/framiactu/json';
      fetch(url)
        .then(res => res.json())
        .then((data) => {
          data.items.every((item) => {
            if (!item.tags.includes('English')
				&& this.url == '#') {
              this.url = item.url;
			  return false;
            }
          });
        })
        .catch((err) => { console.error(err) }); // eslint-disable-line
    },
  },
};
</script>
<style>
.peertube-wrapper {
    padding: 3rem 1rem 2rem;
    border-radius: 1.75rem;
    background-color: var(--f-g2);
}

.peertube-wrapper h3 {
    max-width: 32ch;
}

.framiactubutton {
	@media (min-width: 768px) {
		text-align: right;
	}
	@media (max-width: 768px) {
		text-align: center;
	}
	text-decoration: none;
	font-family: Tovari Sans, sans-serif;
	font-size: 2em;
	padding: 0.4em 0.8em;
	background-color: #eee;
	border-radius: 12px;
	margin-right: 3%;
	margin-left: 3%;
}

.framiactusection {
	display: flex;
	@media (min-width: 768px) {
		justify-content: right;
	}
	@media (max-width: 768px) {
		justify-content: center;
	}
}
</style>

